import { motion } from 'framer-motion'
import styled from 'styled-components'
import { AI_HELP_RESERVED_SPACE_CSS_VAR } from '@constants/layout'

export const SecondaryModalContent = styled(motion.div).attrs({
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 }
})`
  position: relative;
  height: 100%;
  padding: ${({ theme }) => theme.spacing.lg}rem;
  background: ${({ theme }) => theme.colors.neutralWhite};
`

export const ModalColumn = styled(motion.div)`
  z-index: 50;
  top: 0;
  left: 0;
  position: absolute;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  overflow: hidden;

  & > div {
    border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  }
`

export const DoubleModalWrapper = styled(motion.div).attrs({
  variants: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 }
  },
  initial: 'init',
  animate: 'show',
  exit: 'exit'
})`
  position: relative;
  max-width: calc(100dvw - var(${AI_HELP_RESERVED_SPACE_CSS_VAR}, 0px));
`

export const ModalOverlay = styled(motion.div).attrs({
  // React 19 + the React Compiler seem to keep the overlay element around
  // for a few frames even after opacity hits 0, which blocks pointer events.
  // Matching ModalV2 behaviour we explicitly toggle pointer events in variants.
  variants: {
    initial: { opacity: 0, pointerEvents: 'none' },
    isOpen: { opacity: 1, pointerEvents: 'auto' },
    exit: {
      opacity: 0,
      pointerEvents: 'none',
      transition: { duration: 0.2 }
    }
  },
  initial: 'initial',
  animate: 'isOpen',
  exit: 'exit'
})`
  position: fixed;
  top: 0;
  left: 0;
  right: var(${AI_HELP_RESERVED_SPACE_CSS_VAR}, 0px);
  bottom: 0;
  z-index: 9000;
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.backdrop};
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (min-width: 376px) {
    overflow: hidden;
  }
`
